import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SearchBox from '../components/SearchBox';

export default function Home() {
  const [query, setQuery] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSearch = (term) => {
    navigate(`/resultados?q=${encodeURIComponent(term)}`);
  };

  return (
    <div>
      <section className="hero">
        <div className="hero-bg" style={{
          backgroundImage: `url('/mpd001.jpeg')`
        }} />
        <div className="hero-overlay" />
        <div className="hero-content">
          <h1>LOCALIZADOR DE JAZIGOS</h1>
          <p>Encontre o local de uma pessoa sepultada no Memorial Parque Dourados.</p>
          <SearchBox
            value={query}
            onChange={setQuery}
            onSubmit={handleSearch}
            loading={loading}
          />
          <div className="search-hint">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
              <circle cx="12" cy="10" r="3"></circle>
            </svg>
            Consulte a localização de jazigos, quadras e setores do cemitério.
            {' '}
            <a href="/mapa" style={{ color: '#F0C76B', fontWeight: 600 }}>Ver todos os pontos no mapa →</a>
          </div>
        </div>
      </section>

      <section className="how-to">
        <div className="container">
          <div className="how-to-eyebrow">Localizador de jazigos</div>
          <h2>Encontre o jazigo online, em poucos passos.</h2>
          <p className="how-to-sub">Nosso localizador permite buscar pelo nome da pessoa e ver a posição do jazigo no mapa do memorial, com navegação em tempo real.</p>
          <ul className="how-to-list">
            <li>Busque pelo nome da pessoa homenageada</li>
            <li>Veja a localização no mapa do cemitério</li>
            <li>Use a navegação GPS para chegar ao jazigo</li>
          </ul>
        </div>
      </section>
    </div>
  );
}
